import * as yup from 'yup';
import { regexTitle } from 'src/app/utils/validations'; // regexRFC

export const schema = yup.object().shape({
  responsibleName: yup
    .string()
    .required('El nombre no puede quedar vacío')
    .min(3, 'El nombre debe contener al menos 3 letras')
    .matches(regexTitle, 'Nombre inválido'),
  responsibleEmail: yup
    .string()
    .email('Debes ingresar un correo válido')
    .required('El correo no puede quedar vacío'),
  responsiblePhoneCode: yup.string().min(1, 'El lada debe tener al menos 1 dígito'),
  responsiblePhone: yup.string().min(10, 'El teléfono debe tener al menos 10 dígitos'),

  fiscalRegime: yup.object().required('El régimen fiscal es obligatorio'),
  rfc: yup.string().required('El RFC es obligatorio'), // .matches(regexRFC, 'Formato de RFC inválido'),
  businessName: yup
    .string()
    .notRequired()
    .min(3, 'El nombre de la empresa debe tener al menos 3 letras'),
  cfdiUse: yup.object().required('El uso de CFDI es obligatorio'),
});
